import React from 'react';
import { useGlobalContext } from './context';
import Increase from './Increase';
import Decrease from './Decrease';

const CartItem = (props) => 
{
  const { id, img, title, price, amount } = props;
  const { removeItem, increaseItem, decreaseItem } = useGlobalContext();
  return (
    <article className='cart-item'>
      <img src={img} alt={title} />
      <div>
        <h4>{title}</h4>
        <h4 className='item-price'>${price}</h4>
        <button className='remove-btn' onClick={() => { removeItem(id) }}>
          remove
        </button>
      </div>
      <div>
        <button className='amount-btn' onClick={ () => { increaseItem(id) } }>
          <Increase />
        </button>
        <p className='amount'>{amount}</p>
        <button className='amount-btn' onClick={ () => { decreaseItem(id) } }>
          <Decrease/>
        </button>
      </div>
    </article>
  )
}

export default CartItem
